import {
  Button,
  CloseButton,
  Grid,
  Heading,
  Modal,
  Spinner,
} from "@instructure/ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export const DialogYesNo = ({
  message,
  openStatus,
  onClickNo,
  onClickYes,
  shouldReturnFocus = true,
}) => {
  const { t } = useTranslation();
  const [loader, setLoader] = useState(false);

  const handleSubmit = async () => {
    setLoader(true);
    await onClickYes();
    setLoader(false);
  };

  return (
    <Modal
      open={openStatus}
      onDismiss={onClickNo}
      size="large"
      label={t("dialogYesNo.confirmation")}
      shouldReturnFocus={shouldReturnFocus}
    >
      <Modal.Header>
        <Grid hAlign="space-between" vAlign="middle">
          <Grid.Row>
            <Grid.Col>
              <Heading level="h2" as="h2">
                {t("dialogYesNo.confirmation")}
              </Heading>
            </Grid.Col>
            <Grid.Col width="auto">
              <CloseButton
                size="small"
                screenReaderLabel={t("global.close")}
                onClick={onClickNo}
              />
            </Grid.Col>
          </Grid.Row>
        </Grid>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        <Button margin="0 small 0 0" onClick={onClickNo}>
          {t("dialogYesNo.no")}
        </Button>
        <Button onClick={handleSubmit} disabled={loader}>
          {loader ? (
            <Spinner renderTitle={t("global.pleaseWait")} size="x-small" />
          ) : (
            t("dialogYesNo.yes")
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
